import React, { useCallback, useState } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector } from 'js/store/hooks';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { WebContentInner } from 'js/components/system/WebContent';
import { CheckboxShallow } from 'js/components/common/Fields/Checkbox';
import { LocalConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';

import style from './TimeIsFlyingPopup.scss';

const popupClassNames = {
    inner: style.popupInner
};

export const TimeIsFlyingPopup = ({ id, data: { disableNotification, onClose } = {} }) => {
    const t = useTranslations('playtech.mobile.system.');
    const closePopup = useOnClose(id);
    const title = t('timeIsFlying');
    const timeIsFlyingWebContent = useAppSelector(prop('timeIsFlyingWebContent'));
    const [showConfirmDialog, setShowConfirmation] = useState(false);
    const [preventShowAgain, setPreventShowAgain] = useState(false);
    const combineClosePopup = useCombinedHandler([closePopup, onClose]);

    const onCloseManaged = useCallback(() => {
        if (preventShowAgain) {
            setShowConfirmation(true);
        } else {
            combineClosePopup();
        }
    }, [combineClosePopup, preventShowAgain]);

    const onShowAgainChange = (e) => {
        setPreventShowAgain(e.target.checked);
    };

    const buttons = [
        {
            text: t('continue'),
            onClick: onCloseManaged
        }
    ];

    return (
        <>
            {!showConfirmDialog && (
                <ManagedPopup title={title} buttons={buttons} classNames={popupClassNames} onClose={combineClosePopup}>
                    <WebContentInner content={timeIsFlyingWebContent} />
                    <CheckboxShallow
                        name="preventShowAgain"
                        label={t('showAgain')}
                        aria-label={t(['showAgain', 'playtech.mobile.system.checkbox.aria-label'])}
                        onChange={onShowAgainChange}
                    />
                </ManagedPopup>
            )}
            {showConfirmDialog && (
                <LocalConfirmationPopup
                    onAccept={disableNotification}
                    className={style.confirmPopup}
                    acceptBtnText="playtech.mobile.system.yes.button.title"
                    declineBtnText="playtech.mobile.system.no.button.title"
                    onClose={combineClosePopup}
                    title={t('title.warning')}
                    content={t('timeIsFlying.confirm')}
                />
            )}
        </>
    );
};
